import { screens } from '../../../../../config/breakpoints';
const { phone_only, tablet } = screens;
const mqlPhoneOnly = window.matchMedia(`(max-width: ${parseFloat(phone_only.max, 10)}px)`);
const mqlTablet = window.matchMedia(`(min-width: ${parseInt(tablet, 10)}px)`);

function initBasicJobSearchFunctions() {
  const standaloneJobSearch = document.querySelector('.section--darkred .job-search-form');
  const redTextClass = 'text-red';

  mqlPhoneOnly.onchange = event => {
    if (event.matches) {
      Array.from(document.querySelectorAll('.job-search-form .text-red')).forEach(elm => {
        elm.classList.remove(redTextClass);
      })
    }
  };

  if (standaloneJobSearch) {
    const [keywordInput, locationInput, distanceInput] = Array.from(standaloneJobSearch.querySelectorAll('input[type="text"]'));

    if (keywordInput) {
      let icon = keywordInput.closest('.job-search-form-input-group').querySelector('.avanti-icon-search');
      keywordInput.addEventListener('mouseenter', event => {
        if (mqlTablet.matches) {
          icon.classList.add(redTextClass);
        }
      });
      keywordInput.addEventListener('mouseleave', event => {
        icon.classList.remove(redTextClass);
      });
    }

    if (locationInput) {
      let icon = locationInput.closest('.job-search-form-input-group').querySelector('.avanti-icon-location');
      locationInput.addEventListener('mouseenter', event => {
        if (mqlTablet.matches) {
          icon.classList.add(redTextClass);
        }
      });
      locationInput.addEventListener('mouseleave', event => {
        icon.classList.remove(redTextClass);
      });
    }

    if (distanceInput) {
      let icon = distanceInput.closest('.job-search-form-input-group').querySelector('a > i');
      distanceInput.addEventListener('mouseenter', event => {
        if (mqlTablet.matches) {
          icon.classList.add(redTextClass);
        }
      });
      distanceInput.addEventListener('mouseleave', event => {
        icon.classList.remove(redTextClass);
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', initBasicJobSearchFunctions);
